import { Directive, Inject } from 'ng-metadata/core';

@Directive({
    selector: '[prm-text]',
})

export class PrmText {
    constructor(@Inject('$element') private $element: JQuery) {
        $element.attr('dir','auto');
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/primoText.directive.ts